<template>
  <div class="content">
    <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <keep-alive exclude="Index">
          <router-view :key="key" />
        </keep-alive>
      </transition>
    </section>
  </div>
</template>

<script>

export default {
  name: 'Main',
  components: {
  },
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.content {
  width: 1000px;
  margin: 10px auto 0;
  background: #ffffff;
  padding: 30px 30px;
  /*min-height: 78vh;*/
}
</style>
